import moment from "moment";
import { BuProfileConstant } from "presentation/constant/BuProfile/BuProfileConstant";
import { useBuProfileVM } from "presentation/hook/BuProfile/useBuProfileVM";
import { useBuProfileTracked } from "presentation/store/BuProfle/BuProfileProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo } from "react";
import { FieldType, HPHInputTextarea, IFieldValue, TimePicker } from "veronica-ui-component/dist/component/core";
import { SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const BasicBuProfileEditPanel: React.FC = () => {
    const [buProfileState] = useBuProfileTracked();
    const buProfileVM = useBuProfileVM();
    const BUPROFILE_CONSTANT = BuProfileConstant.buProfile;
    const buProfile = buProfileState.buProfile;

    const getStartTime = (hours: number, min: number) => {
        const sysdate = moment();
        sysdate.hours(hours);
        sysdate.minutes(min);
        return sysdate
    }

    return <div className='column' id='ColoumOne'>
        <div className='column-inner-wrapper'>
            <SidebarTitle>{buProfile.buCode ?? ""}</SidebarTitle>
            <div className='inner-div'>
            </div>
            <div className='inner-div' style={{ width: "150px" }}>
                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={buProfile.buCode || ''}
                    fieldValue={buProfile.buCode}
                    fieldLabel={BUPROFILE_CONSTANT.BUCODE}
                    isSaveClicked={false}
                    fieldType={FieldType.TEXT}
                    fieldKey={'buCode'}
                    maxLength={10}
                    isTextFieldCapitalize={false}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
            </div>
            <div className='inner-div' style={{ width: "150px" }}>

                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={buProfile?.timezone ?? ""}
                    fieldValue={buProfile?.timezone}
                    fieldLabel={BUPROFILE_CONSTANT.TIME_ZONE}
                    isSaveClicked={false}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'timezone'}
                    maxLength={60}
                    options={buProfileState.dynamicOptions.timezoneDropdownOptions}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            </div>
            <div className='inner-div' style={{ width: "100%" }}>
                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={buProfile.buName || ''}
                    fieldValue={buProfile.buName}
                    fieldLabel={BUPROFILE_CONSTANT.BUNAME}
                    isSaveClicked={false}
                    fieldType={FieldType.TEXT}
                    fieldKey={'buName'}
                    maxLength={300}
                    isTextFieldCapitalize={false}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
            </div>
            <div className='inner-div' style={{ width: "150px" }}>

                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={buProfile?.country ?? ""}
                    fieldValue={buProfile?.country}
                    fieldLabel={BUPROFILE_CONSTANT.COUNTRY}
                    isSaveClicked={false}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'country'}
                    maxLength={60}
                    options={buProfileState.dynamicOptions.countryDropdownOptions}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            </div>

            <div className='inner-div' style={{ width: "150px" }}>

                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={buProfile?.localCurrencyCode ?? ""}
                    fieldValue={buProfile?.localCurrencyCode}
                    fieldLabel={BUPROFILE_CONSTANT.LOCAL_CURRENCY_CODE}
                    isSaveClicked={false}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'localCurrencyCode'}
                    maxLength={60}
                    options={buProfileState.dynamicOptions.currencyCodeDropdownOptions}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        buProfileVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            </div>
            <div className='inner-div'>
                <TimePicker
                    width='150px'
                    maxLength={2}
                    label={BUPROFILE_CONSTANT.START_HOUR}
                    type="number"
                    minLength={2}
                    value={getStartTime(buProfile.startHour ?? 0, buProfile.startMin ?? 0).toDate()}
                    onChange={(e: any) => buProfileVM.onTimePickerChange(e, 'startHour', 'startMin')} />
            </div>
            <div className='inner-div'>
                <HPHInputTextarea
                    label={BUPROFILE_CONSTANT.ADDRESS}
                    width="100%"
                    rows={3}
                    resizable={false}
                    value={buProfile.address ?? ""}
                    onChange={(e) => { buProfileVM.onTextAreaChange(e, "address") }} />
            </div>
        </div>
    </div>
}

export default memo(BasicBuProfileEditPanel);